<icc-list [searchable]="true" [items]="profiles" [itemTemplate]="itemProfile"
  [selected]="selectedProfileId"
  itemWidth="full"
  itemImgHeight="medium"
  [ignoreTemplateWidth]="true"
  (select)="selectProfile($event)"
[tabs]="showTabs ? tabs : null"></icc-list>

<ng-template #itemProfile let-item="iccListItem">
  <div class="item-imgTitleDescription">
    <div class="icc-list-item-img-container">
      <img class="item-imgTitleDescription-img" [src]="item.imageUrl"
        [alt]="item.title"
        defaultImg>
      </div>
      <p class="item-imgTitleDescription-title">{{item.title}}
        @if (isWysiwygEditorContentNotEmpty(item)) {
          <button mat-mini-fab class="item-imgTitleDescription-info-button mat-elevation-z0" (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
            <mat-icon class="mat-18">info</mat-icon>
          </button>
        }
      </p>
      <p class="item-imgTitleDescription-description">
        {{item.description}}
      </p>
      @if (item.type === 'extension' || item.type === 'sandwich' || item.type === 'coupling' && showColorsWhenCoupling) {
        <p class="item-imgTitleDescription-color"
          >
          @if (item.selectedWood?.name) {
            <span
              >{{ 'WINDOW|Rodzaj drewna' | translate }}:
              <b>{{ item.selectedWood?.name }}</b>
              <br />
            </span>
          }
          @if (item.selectedColor?.outer?.id === item.selectedColor?.inner?.id) {
            <span
              >{{ 'WINDOW|Kolor' | translate }}:
              <b>{{ item.selectedColor?.outer?.name }}</b>
              <br />
            </span>
          }
          @if (item.selectedColor?.outer?.id !== item.selectedColor?.inner?.id) {
            @if (item.selectedColor?.outer?.name) {
              <span>{{ 'WINDOW|Kolor zewn.' | translate }}:
                <b>{{ item.selectedColor?.outer?.name }}</b>
                <br />
              </span>
            }
            @if (item.selectedColor?.inner?.name) {
              <span>{{ 'WINDOW|Kolor wewn.' | translate }}:
                <b>{{ item.selectedColor?.inner?.name }}</b>
                <br />
              </span>
            }
          }
          @if (!item.selectedColor?.outer?.isCore &&
            !item.selectedColor?.inner?.isCore &&
            item.selectedColor?.core?.name &&
            config().IccConfig.Configurators.showCoreColorInAdditionalProfilesAndAccessories
            ) {
            <span
              >{{ 'WINDOW|Kolor bazy' | translate }}:
              <b>{{ item.selectedColor?.core?.name }}</b>
              <br />
            </span>
          }
          @if (config().IccConfig.Configurators.extensionsReinforcements && item.type === 'extension') {
            <span>{{ 'WINDOW|Wzmocnienie' | translate }}:
              @if (item.reinforcement?.name) {
                <b>{{ item.reinforcement?.name }}</b>
              }
              @if (!item.reinforcement?.name) {
                <b>{{ 'INTERFACE|Brak' | translate }}</b>
              }
              <br />
            </span>
          }
        </p>
      }
      @if (!hiddenPrice) {
        <p class="item-imgTitleDescription-price">
          {{ 'CONFIGURATOR|Cena' | translate }}:<br>
          <b>
            @if (hasZeroPrice(item.price, item.type) && (!config().IccConfig.Configurators.extensionsReinforcements || item.type !== 'extension' || !item.reinforcement || item.reinforcement.price === 0)) {
              <span
                >{{ 'CONFIGURATOR|W cenie' | translate }}<br></span>
              }
              @if (hasNoPrice(item.price, item.type)) {
                <span
                  >{{ 'CONFIGURATOR|Do wyceny' | translate }}<br></span>
                }
                @if (!hasZeroPrice(item.price, item.type) && ! hasNoPrice(item.price, item.type)) {
                  <span
                    >
                    @if (item.price.price_field && (!config().IccConfig.Configurators.price.frameProfilesAlt || item.type != 'frame')) {
                      <span
                        >
                        @if (item.price.list_price_field && item.price.list_price_field !== item.price.price_field && listPriceEnable && listPriceEnableInMarket) {
                          <s>
                            {{priceMarket(item.price.list_price_field) | currency: currency}}
                          </s>
                        }
                        @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_field) {
                          <span>
                            {{priceMarket(item.price.price_field) | currency: currency}}/{{ 'WINDOW|pole' | translate }}
                          </span>
                        }
                        @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_field) {
                          <span>
                            {{priceMarket(item.price.list_price_field) | currency: currency}}/{{ 'WINDOW|pole' | translate }}
                          </span>
                        }
                        <br>
                        </span>
                      }
                      @if (item.price.price_length && (!config().IccConfig.Configurators.price.frameProfilesAlt || item.type != 'frame')) {
                        <span
                          >
                          {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                          @if (item.price.list_price_length && item.price.list_price_length !== item.price.price_length && listPriceEnable && listPriceEnableInMarket) {
                            <s>
                              {{priceMarket(item.price.list_price_length) + (config().IccConfig.Configurators.extensionsReinforcements && item.reinforcement ? item.reinforcement.price : 0) | unitm:0:0:3 | currency: currency}}
                            </s>
                          }
                          @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_length) {
                            <span>
                              {{priceMarket(item.price.price_length) + (config().IccConfig.Configurators.extensionsReinforcements && item.reinforcement ? item.reinforcement.price : 0) | unitm:0:0:3 | currency: currency}}/
                            </span>
                          }
                          @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_length) {
                            <span>
                              {{priceMarket(item.price.list_price_length) + (config().IccConfig.Configurators.extensionsReinforcements && item.reinforcement ? item.reinforcement.price : 0) | unitm:0:0:3 | currency: currency}}/
                            </span>
                          }
                          <span [innerHTML]="2|formatUnit"></span><br>
                        </span>
                      }
                      @if (item.price.price_area) {
                        <span
                          >
                          @if (item.price.list_price_area && item.price.list_price_area !== item.price.price_area && listPriceEnable && listPriceEnableInMarket) {
                            <s>
                              {{priceMarket(item.price.list_price_area) | currency: currency}}
                            </s>
                          }
                          @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_area) {
                            <span>
                              {{priceMarket(item.price.price_area) | currency: currency}}/
                            </span>
                          }
                          @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_area) {
                            <span>
                              {{priceMarket(item.price.list_price_area) | currency: currency}}/
                            </span>
                          }
                          <span [innerHTML]="1|formatUnit"></span><br>
                        </span>
                      }
                      @if (item.price.price_field != item.price.price_length &&  config().IccConfig.Configurators.price.frameProfilesAlt && item.type == 'frame') {
                        <span
                          >
                          {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                          @if (item.price.list_price_length && item.price.list_price_length !== item.price.price_length && listPriceEnable && listPriceEnableInMarket) {
                            <s>
                              {{priceMarket(item.price.list_price_length) | unitm:0:0:3 | currency: currency}}
                            </s>
                          }
                          @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_length) {
                            <span>
                              {{priceMarket(item.price.price_length) | unitm:0:0:3 | currency: currency}}/
                            </span>
                          }
                          @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_length) {
                            <span>
                              {{priceMarket(item.price.list_price_length) | unitm:0:0:3 | currency: currency}}/
                            </span>
                          }
                          <span [innerHTML]="2|formatUnit"></span>
                          @if (item.price.price_field) {
                            <span
                              >{{ 'INTERFACE|lub' | translate }}&nbsp;
                              @if (item.price.list_price_field && item.price.list_price_field !== item.price.price_field && listPriceEnable && listPriceEnableInMarket) {
                                <s>
                                  {{priceMarket(item.price.list_price_field) | unitm:0:0:3 | currency: currency}}
                                </s>
                              }
                              @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_field) {
                                <span>
                                  {{priceMarket(item.price.price_field) | unitm:0:0:3 | currency: currency}}/
                                </span>
                              }
                              @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_field) {
                                <span>
                                  {{priceMarket(item.price.list_price_field) | unitm:0:0:3 | currency: currency}}
                                </span>
                              }
                              <span [innerHTML]="2|formatUnit"></span>
                            </span>
                            }<br>
                          </span>
                        }
                        @if (item.price.price_length && item.price.price_field == item.price.price_length &&  config().IccConfig.Configurators.price.frameProfilesAlt && item.type == 'frame') {
                          <span
                            >
                            {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                            @if (item.price.list_price_length && item.price.list_price_length !== item.price.price_length && listPriceEnable && listPriceEnableInMarket) {
                              <s>
                                {{priceMarket(item.price.list_price_length) | unitm:0:0:3 | currency: currency}}
                              </s>
                            }
                            @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_length) {
                              <span>
                                {{priceMarket(item.price.price_length) | unitm:0:0:3 | currency: currency}}/
                              </span>
                            }
                            @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_length) {
                              <span>
                                {{priceMarket(item.price.list_price_length) | unitm:0:0:3 | currency: currency}}
                              </span>
                            }
                            <span [innerHTML]="2|formatUnit"></span><br>
                          </span>
                        }
                        @if (item.price.price_piece) {
                          <span
                            >
                            @if (item.price.list_price_piece && item.price.list_price_piece !== item.price.price_piece && listPriceEnable && listPriceEnableInMarket) {
                              <s>
                                {{priceMarket(item.price.list_price_piece) | currency: currency}}
                              </s>
                            }
                            @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_piece) {
                              <span>
                                {{priceMarket(item.price.price_piece) | currency: currency}}/{{ 'UNIT|szt.' | translate }}<br>
                              </span>
                            }
                            @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_piece) {
                              <span>
                                {{priceMarket(item.price.list_price_piece) | currency: currency}}/{{ 'UNIT|szt.' | translate }}<br>
                              </span>
                            }
                          </span>
                        }
                        @if (item.price.price_construction) {
                          <span
                            >
                            @if (item.price.list_price_construction && item.price.list_price_construction !== item.price.price_construction && listPriceEnable && listPriceEnableInMarket) {
                              <s>
                                {{priceMarket(item.price.list_price_construction) | currency: currency}}
                              </s>
                            }
                            @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_construction) {
                              <span>
                                {{priceMarket(item.price.price_construction) | currency: currency}}/{{ 'WINDOW|konstrukcja' | translate }}<br>
                              </span>
                            }
                            @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_construction) {
                              <span>
                                {{priceMarket(item.price.list_price_construction) | currency: currency}}/{{ 'WINDOW|konstrukcja' | translate }}<br>
                              </span>
                            }
                          </span>
                        }
                        @if (item.price.price_percent) {
                          <span
                            >
                            @if (item.price.list_price_percent && item.price.list_price_percent !== item.price.price_percent && listPriceEnable && listPriceEnableInMarket) {
                              <s>
                                {{item.price.list_price_percent}}%
                              </s>
                            }
                            @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.price.list_price_percent) {
                              <span>
                                {{item.price.price_percent}}%
                              </span>
                            }
                            @if (listPriceEnable && !listPriceEnableInMarket && item.price.list_price_percent) {
                              <span>
                                {{item.price.list_price_percent}}%
                              </span>
                            }
                          </span>
                        }
                      </span>
                    }
                  </b>
                </p>
              }
            </div>
          </ng-template>
